//sound
import a from "../../assets/audio/letter-a.mp3";
import b from "../../assets/audio/letter-b.mp3";
import c from "../../assets/audio/letter-c.mp3";
import d from "../../assets/audio/letter-d.mp3";
import e from "../../assets/audio/letter-e.mp3";
import f from "../../assets/audio/letter-f.mp3";
import g from "../../assets/audio/letter-g.mp3";
import h from "../../assets/audio/letter-h.mp3";
import i from "../../assets/audio/letter-i.mp3";
import j from "../../assets/audio/letter-j.mp3";
import k from "../../assets/audio/letter-k.mp3";
import l from "../../assets/audio/letter-l.mp3";
import m from "../../assets/audio/letter-m.mp3";
import n from "../../assets/audio/letter-n.mp3";
import o from "../../assets/audio/letter-o.mp3";
import p from "../../assets/audio/letter-p.mp3";
import q from "../../assets/audio/letter-q.mp3";
import r from "../../assets/audio/letter-r.mp3";
import s from "../../assets/audio/letter-s.mp3";
import t from "../../assets/audio/letter-t.mp3";
import u from "../../assets/audio/letter-u.mp3";
import v from "../../assets/audio/letter-v.mp3";
import w from "../../assets/audio/letter-w.mp3";
import x from "../../assets/audio/letter-x.mp3";
import y from "../../assets/audio/letter-y.mp3";
import z from "../../assets/audio/letter-z.mp3";

import apple from "../../assets/audio/apple.mp3";
import banana from "../../assets/audio/banana.mp3";
import cat from "../../assets/audio/cat.mp3";
import dog from "../../assets/audio/dog.mp3";
import elephant from "../../assets/audio/elephant.mp3";
import fox from "../../assets/audio/fox.mp3";
import giraffe from "../../assets/audio/giraffe.mp3";
import hat from "../../assets/audio/hat.mp3";
import ice_cream from "../../assets/audio/ice cream.mp3";
import juice from "../../assets/audio/juice.mp3";
import key from "../../assets/audio/key.mp3";
import lion from "../../assets/audio/lion.mp3";
import mouse from "../../assets/audio/mouse.mp3";
import nut from "../../assets/audio/nut.mp3";
import orange from "../../assets/audio/orange.mp3";
import panda from "../../assets/audio/panda.mp3";
import queen from "../../assets/audio/queen.mp3";
import rabbit from "../../assets/audio/rabbit.mp3";
import sun from "../../assets/audio/sun.mp3";
import tiger from "../../assets/audio/tiger.mp3";
import unicorn from "../../assets/audio/unicorn.mp3";
import vase from "../../assets/audio/vase.mp3";
import wolf from "../../assets/audio/wolf.mp3";
import xylophone from "../../assets/audio/xylophone.mp3";
import yoyo from "../../assets/audio/yoyo.mp3";
import zebra from "../../assets/audio/zebra.mp3";

//images
import bananaPng from '../icon/banana.png';
import applePng from '../icon/apple.png';
import catPng from '../icon/cat.png';
import dogPng from '../icon/dog.png';
import elephantPng from '../icon/elephant.png';
import foxPng from '../icon/fox.png';
import giraffePng from '../icon/giraffe.png';
import hatPng from '../icon/hat.png';
import ice_creamPng from '../icon/ice-cream.png';
import juicePng from '../icon/orange-juice.png';
import keyPng from '../icon/key.png';
import lionPng from '../icon/lion.png';
import mousePng from '../icon/mouse.png';
import nutPng from '../icon/nut.png';
import orangePng from '../icon/orange.png';
import pandaPng from '../icon/panda.png';
import queenPng from '../icon/queen.png';
import rabbitPng from '../icon/rabbit.png';
import sunPng from '../icon/sun.png';
import tigerPng from '../icon/tiger.png';
import unicornPng from '../icon/unicorn.png';
import vasePng from '../icon/vase.png';
import xylophonePng from '../icon/xylophone-instrument.png';
import wolfPng from '../icon/wolf.png';
import yoyoPng from '../icon/yoyo.png';
import zebraPng from '../icon/zebra.png';

export const audioAlphabet = {
  A: a,
  B: b,
  C: c,
  D: d,
  E: e,
  F: f,
  G: g,
  H: h,
  I: i,
  J: j,
  K: k,
  L: l,
  M: m,
  N: n,
  O: o,
  P: p,
  Q: q,
  R: r,
  S: s,
  T: t,
  U: u,
  V: v,
  W: w,
  X: x,
  Y: y,
  Z: z,
  Apple: apple,
  Banana: banana,
  Cat: cat,
  Dog: dog,
  Elephant: elephant,
  Fox: fox,
  Giraffe: giraffe,
  Hat: hat,
  "Ice Cream": ice_cream,
  Juice: juice,
  Key: key,
  Lion: lion,
  Mouse: mouse,
  Nut: nut,
  Orange: orange,
  Panda: panda,
  Queen: queen,
  Rabbit: rabbit,
  Sun: sun,
  Tiger: tiger,
  Unicorn: unicorn,
  Vase: vase,
  Wolf: wolf,
  Xylophone: xylophone,
  Yoyo: yoyo,
  Zebra: zebra,
};

export const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const styleAlphabet = [
  {
    letter: "A",
    color: "#F06543",
    borderColor: "#A82525",
    src: applePng,
    name: "Apple",
  },
  {
    letter: "B",
    color: "#F99B28",
    borderColor: "#A82525",
    src: bananaPng,
    name: "Banana",
  },
  {
    letter: "C",
    color: "#FEF723",
    borderColor: "#A82525",
    src: catPng,
    name: "Cat",
  },
  {
    letter: "D",
    color: "#B5D444",
    borderColor: "#A82525",
    src: dogPng ,
    name: "Dog",
  },
  {
    letter: "E",
    color: "#0AADE8",
    borderColor: "#A82525",
    src: elephantPng,
    name: "Elephant",
  },
  {
    letter: "F",
    color: "#EA259D",
    borderColor: "#A82525",
    src: foxPng,
    name: "Fox",
  },
  {
    letter: "G",
    color: "#363190",
    borderColor: "#A82525",
    src: giraffePng,
    name: "Giraffe",
  },
  {
    letter: "H",
    color: "#F9403C",
    borderColor: "#A82525",
    src: hatPng,
    name: "Hat",
  },
  {
    letter: "I",
    color: "#F5901E",
    borderColor: "#A82525",
    src:ice_creamPng,
    name: "Ice Cream",
  },
  {
    letter: "J",
    color: "#FFF11A",
    borderColor: "#A82525",
    src: juicePng,
    name: "Juice",
  },
  {
    letter: "K",
    color: "#B7D340",
    borderColor: "#A82525",
    src: keyPng,
    name: "Key",
  },
  {
    letter: "L",
    color: "#0AADE9",
    borderColor: "#A82525",
    src: lionPng,
    name: "Lion",
  },
  {
    letter: "M",
    color: "#EA008D",
    borderColor: "#A82525",
    src: mousePng,
    name: "Mouse",
  },
  {
    letter: "N",
    color: "#2E2B92",
    borderColor: "#A82525",
    src: nutPng,
    name: "Nut",
  },
  {
    letter: "O",
    color: "#F6A01A",
    borderColor: "#A82525",
    src:orangePng,
    name: "Orange",
  },
  {
    letter: "P",
    color: "#F59120",
    borderColor: "#A82525",
    src: pandaPng,
    name: "Panda",
  },
  {
    letter: "Q",
    color: "#F8EA13",
    borderColor: "#A82525",
    src: queenPng,
    name: "Queen",
  },
  {
    letter: "R",
    color: "#B3D43A",
    borderColor: "#A82525",
    src: rabbitPng,
    name: "Rabbit",
  },
  {
    letter: "S",
    color: "#04ACE4",
    borderColor: "#A82525",
    src: sunPng,
    name: "Sun",
  },
  {
    letter: "T",
    color: "#D9077D",
    borderColor: "#A82525",
    src: tigerPng,
    name: "Tiger",
  },
  {
    letter: "U",
    color: "#2E2E8C",
    borderColor: "#A82525",
    src: unicornPng,
    name: "Unicorn",
  },
  {
    letter: "V",
    color: "#ED3131",
    borderColor: "#A82525",
    src: vasePng,
    name: "Vase",
  },
  {
    letter: "W",
    color: "#F7901B",
    borderColor: "#A82525",
    src: wolfPng,
    name: "Wolf",
  },
  {
    letter: "X",
    color: "#F9F506",
    borderColor: "#A82525",
    src: xylophonePng,
    name: "Xylophone",
  },
  {
    letter: "Y",
    color: "#B7D64A",
    borderColor: "#A82525",
    src: yoyoPng,
    name: "Yoyo",
  },
  {
    letter: "Z",
    color: "#02AFE8",
    borderColor: "#A82525",
    src: zebraPng,
    name: "Zebra",
  },
];
